import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

import LandingPage from '@/pages/LandingPage';
import BookingPage from '@/pages/BookingPage';
import PaymentPage from '@/pages/PaymentPage';
import ConfirmationPage from '@/pages/ConfirmationPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import MyBookingsPage from '@/pages/MyBookingsPage';

import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminVenues from '@/pages/admin/AdminVenues';
import AdminBookings from '@/pages/admin/AdminBookings';
import AdminUsers from '@/pages/admin/AdminUsers';
import AdminPaymentConfig from '@/pages/admin/AdminPaymentConfig';
import AdminChangePassword from '@/pages/admin/AdminChangePassword';
import AdminSettings from '@/pages/admin/AdminSettings';
import AdminMembers from '@/pages/admin/AdminMembers';
import AdminVenueForm from '@/pages/admin/AdminVenueForm';
import AdminLiveLapang from '@/pages/admin/AdminLiveLapang';
import AdminVouchers from '@/pages/admin/AdminVouchers';
import AdminTransactions from '@/pages/admin/AdminTransactions';
import AdminLaporanLapangan from '@/pages/admin/AdminLaporanLapangan';
import AdminSumberDana from '@/pages/admin/AdminSumberDana';
import AdminPengeluaran from '@/pages/admin/AdminPengeluaran';
import AdminAuditLogs from '@/pages/admin/AdminAuditLogs';

import KasirLogin from '@/pages/kasir/KasirLogin';
import KasirBooking from '@/pages/kasir/KasirBooking';
import KasirDashboard from '@/pages/kasir/KasirDashboard';
import KasirWhatsApp from '@/pages/kasir/KasirWhatsApp';
import AdminReports from '@/pages/admin/AdminReports';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/booking/:venueId" element={<BookingPage />} />
          <Route path="/payment/:bookingId" element={<PaymentPage />} />
          <Route path="/confirmation/:bookingId" element={<ConfirmationPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/my-bookings" element={<MyBookingsPage />} />
          
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/venues" element={<AdminVenues />} />
          <Route path="/admin/venues/new" element={<AdminVenueForm />} />
          <Route path="/admin/venues/:venueId/edit" element={<AdminVenueForm />} />
          <Route path="/admin/bookings" element={<AdminBookings />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/payment-config" element={<AdminPaymentConfig />} />
          <Route path="/admin/change-password" element={<AdminChangePassword />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/members" element={<AdminMembers />} />
          <Route path="/admin/live-lapang" element={<AdminLiveLapang />} />
          <Route path="/admin/vouchers" element={<AdminVouchers />} />
          <Route path="/admin/transactions" element={<AdminTransactions />} />
          <Route path="/admin/laporan-lapangan" element={<AdminLaporanLapangan />} />
          <Route path="/admin/sumber-dana" element={<AdminSumberDana />} />
          <Route path="/admin/pengeluaran" element={<AdminPengeluaran />} />
          <Route path="/admin/audit-logs" element={<AdminAuditLogs />} />
          
          <Route path="/kasir/login" element={<KasirLogin />} />
          <Route path="/kasir/booking" element={<KasirBooking />} />
          <Route path="/kasir/dashboard" element={<KasirDashboard />} />
          <Route path="/kasir/bookings" element={<AdminBookings />} />
          <Route path="/kasir/whatsapp" element={<KasirWhatsApp />} />
          <Route path="/admin/reports" element={<Navigate to="/admin/reports/pemasukan" replace />} />
          <Route path="/admin/reports/pemasukan" element={<AdminReports />} />
          <Route path="/admin/reports/pengeluaran" element={<AdminPengeluaran mode="report" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
